module.exports = __webpack_public_path__ + "static/media/chestXray.e2762984.png";